import Exception404 from './404.vue'

export default Exception404
